const Metrics = {
    doubleBaseMargin: 32,
    baseMargin: 16,
    smallMargin: 8,
    tinyMargin: 4,
    buttonRadius: 10,
    icons: {
        small: 16,
        regular: 24,
        large: 48,
    }
};

export default Metrics;